import React from 'react';
import { generatePath } from 'react-router-dom';
import AuthRoutes from '@/constants/routing/AuthRoutes';
import RouterLink from './RouterLink';

export default function ConstituentLink({
  constituentId,
  displayName,
}: {
  constituentId: string;
  displayName: string;
}) {
  return (
    <RouterLink
      to={generatePath(AuthRoutes.CONSTITUENT, {
        constituentId,
      })}
    >
      {displayName}
    </RouterLink>
  );
}
